import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminViewComponent } from './admin-view.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseHighlightModule } from '@fuse/components';
import { RouterModule } from '@angular/router';
import { AngularMaterialModule } from 'app/angular-material.module';
import { SharedModule } from '../common/shared.module';
import { FuseWidgetModule } from '../fuse/components/widget/widget.module';
import { FuseShortcutsModule } from '../fuse/components/shortcuts/shortcuts.module';

@NgModule({
  declarations: [
    AdminViewComponent
  ],
  exports: [
    FuseSharedModule,
    FuseHighlightModule,
    FuseWidgetModule,
  ],
  imports: [
    CommonModule,
    FuseSharedModule,
    FuseHighlightModule, 
    FuseWidgetModule,
    RouterModule,
    AngularMaterialModule,
    SharedModule,
    FuseShortcutsModule
  ],
  providers: [
  ]
})
export class AdminViewModule { }
